import { TransactionTime } from "@ctypes";
import { useTransactions } from "./useTransactions";

export const usePastTransactions = () => {
  return useTransactions({
    time: TransactionTime.Past,
  });
};
